/**
 * Script personnalisé : empêche la navigation sur "Edition 2026"
 * et maintient le sous-menu ouvert au clic.
 */
(function () {
  function initEdition2026Menu() {
    var menuLinks = document.querySelectorAll('header-menu .menu-list__link');

    menuLinks.forEach(function (link) {
      if (link.dataset.edition2026Init) return;

      var titleEl = link.querySelector('.menu-list__link-title');
      if (!titleEl) return;

      var title = titleEl.textContent.trim().toLowerCase();
      if (title !== 'edition 2026') return;

      link.dataset.edition2026Init = 'true';

      link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var listItem = link.closest('.menu-list__list-item');
        if (!listItem) return;

        var isExpanded = link.getAttribute('aria-expanded') === 'true';
        if (isExpanded) return;

        listItem.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEdition2026Menu);
  } else {
    initEdition2026Menu();
  }

  document.addEventListener('shopify:section:load', initEdition2026Menu);
})();